<template>
    <div>
        <b-modal id="modal-add-rekening-bank" title="Tambah Rekening Baru">
            <b-form-group label="Bank Tujuan">
                <StateInputHandler
                    :isLoading="stateOptionsBank.isLoading"
                    :error="stateOptionsBank.error"
                    errorMessage="Gagal memuat bank tujuan."
                    @retry="getOptionsBank"
                    fullWidth
                >
                    <multiselect v-model="formsRekening.bank" :options="optionsBank" :internal-search="true"
                        :allow-empty="false" label="name" track-by="id"
                        placeholder="-- Pilih Bank --" />
                </StateInputHandler>
            </b-form-group>
            <b-form-group label="Nomor Rekening">
                <b-form-input
                    v-model="formsRekening.noRek"
                    placeholder="Masukkan nomor rekening"
                    maxlength="20"
                    inputmode="numeric"
                    required
                ></b-form-input>
            </b-form-group>
            <b-form-group label="Nama Anggota Terdaftar" disabled>
                <b-form-input
                    :value="userData.namaAnggota"
                    required
                ></b-form-input>
            </b-form-group>
            <template v-slot:modal-footer="{ cancel }">
                <b-button variant="secondary" name="closeBtn" @click="cancel()">
                    Cancel
                </b-button>
                <b-button variant="primary" name="submitBtn" @click="onShowConfirmAddRekening">
                    Submit
                </b-button>
            </template>
        </b-modal>

        <ModalConfirm id="modal-confirm-add-rekening" title="Konfirmasi Tambah Rekening" :isSubmitting="isLoadingSubmit || isLoadingCheckRekening"
            :desc="`Apakah Anda yakin ingin menambahkan rekening ${formsRekening.bank.name} - ${formsRekening.noRek}?`" @submit="onCheckRekening" />

        <ModalVerifikasiRekeningKasir 
            :namaAnggota="rowRekening ? rowRekening.namaAnggota : ''"
            :namaRekening="rowRekening ? rowRekening.namaPemilikRekening : ''"
            :isLoading="isLoadingSubmit"
            @reject="onRejectVerifikasiRekening"
            @submit="onSubmitVerifikasiRekening"
        />
    </div>
</template>

<script>
import StateInputHandler from '@/components/common/StateInputHandler'
import ModalVerifikasiRekeningKasir from '@/components/modals/ModalVerifikasiRekeningKasir'

export default {
    name: 'modal-add-rekening-bank',
    props: {
        userData: {
            type: Object,
            required: true,
        },
        stateOptionsBank: {
            type: Object,
            default: () => ({}),
        },
        optionsBank: {
            type: Array,
            default: () => [],
        },
        getOptionsBank: {
            type: Function,
            default: () => {},
        }
    },
    components: {
        StateInputHandler,
        ModalVerifikasiRekeningKasir,
    },
    data() {
        return {
            formsRekening: {
                bank: '',
                noRek: '',
            },
            isLoadingSubmit: false,
            isLoadingCheckRekening: false,
            rowRekening: null,
        }
    },
    methods: {
        onShowConfirmAddRekening() {
            this.$bvModal.show("modal-confirm-add-rekening")
        },
        onCheckRekening() {
            if (this.$helper.isNullOrEmpty(this.formsRekening.bank)) {
                this.$helper.toastErr(this, "Mohon memilih bank terlebih dahulu!")
                return
            }

            const { valid: validateNoRek, message } = this.validateNomorRekening(this.formsRekening.noRek)
            if (!validateNoRek) {
                this.$helper.toastErr(this, message)
                return
            }

            const bank = this.optionsBank.find(
                bank => bank.id === this.formsRekening.bank.id
            )

            const params = {
                bankCode: bank ? bank.code : '',
                number: this.formsRekening.noRek,
                nasabahId: this.userData.nasabahId,
            }

            this.rowRekening = null;
            this.isLoadingCheckRekening = true;
            this.$axios.get('nasabah/check-bank/', { params: params }).then(response => {
                const isValid = response.data.isValid
                this.rowRekening = response.data
                const invalidRekening = response.data.namaPemilikRekening == '-'

                if (invalidRekening) {
                    const message = response.data.message
                    this.$helper.toastErr(this, message)
                    return;
                }
                
                if (isValid) {
                    this.onSubmitVerifikasiRekening()
                    return;
                }

                this.$bvModal.show('modal-verifikasi-rekening-kasir')
            }).catch(error => {
                this.$helper.parseError(this, error)
            }).finally(() => {
                this.isLoadingCheckRekening = false;
            })
        },
        onSubmitAddRekening() {
            const payload = {
                nasabahId: this.userData.nasabahId,
                bankId: this.formsRekening.bank.id,
                number: this.formsRekening.noRek,
            }

            this.isLoadingSubmit = true;
            this.$axios.post('nasabah/create-bank-account', {}, { params: payload }).then(response => {
                const invalidBank = response.data.id == null
                const messageError = response.data.name
                if (invalidBank) {
                    this.$helper.toastErr(this, messageError)
                    this.$bvModal.hide("modal-confirm-add-rekening")
                    return
                }

                this.$helper.toastSucc(this, "Rekening berhasil ditambah.")
                this.$bvModal.hide("modal-add-rekening-bank")
                this.$bvModal.hide("modal-confirm-add-rekening")
                this.$bvModal.hide('modal-verifikasi-rekening-kasir')
                this.$emit('onSubmitAddRekening')
                this.formsRekening = {
                    bank: '',
                    noRek: '',
                }
            }).catch(error => {
                this.$helper.parseError(this, error)
            }).finally(() => {
                this.isLoadingSubmit = false;
            })
        },
        validateNomorRekening(noRek) {
            if (!noRek || noRek.trim() === '') {
                return { valid: false, message: "Nomor rekening tidak boleh kosong!" }
            }

            const cleanNoRek = noRek.replace(/[\s-]/g, '')

            if (!/^[0-9]+$/.test(cleanNoRek)) {
                return { valid: false, message: "Nomor rekening hanya boleh berisi angka!" }
            }

            return {
                valid: true,
                message: "SUCCESS"
            }
        },
        onRejectVerifikasiRekening() {
            this.$bvModal.hide('modal-verifikasi-rekening-kasir')
            this.$bvModal.hide("modal-add-rekening-bank")
            this.$bvModal.hide("modal-confirm-add-rekening")
            this.formsRekening = {
                bank: '',
                noRek: '',
            }
        },
        onSubmitVerifikasiRekening() {
            this.onSubmitAddRekening()
        },
    },
}
</script>